export default "__VITE_ASSET__BUr2OtGn__"